import { limparTodosAnexos } from "../infrastructure/persistence/anexosPendentes.storage";
import { LISTAGEM_STORAGE_KEY } from "../infrastructure/persistence/listagem.storage";
import {
  WIZARD_STORAGE_PREFIXO,
  WIZARD_ABA_STORAGE_PREFIXO
} from "../infrastructure/persistence/wizardPassos.storage";

function limparStorage(obterStorage, pertenceAoModulo) {
  try {
    const storage = obterStorage();
    for (let indice = storage.length - 1; indice >= 0; indice--) {
      const chave = storage.key(indice);
      if (chave && pertenceAoModulo(chave)) storage.removeItem(chave);
    }
  } catch (error) {
    console.warn("Erro ao limpar armazenamento do relato de ocorrência", error);
  }
}

export async function limparSessaoRelatoOcorrencia(commit) {
  commit("relatoOcorrencia/RESET_FILTROS");
  commit("relatoOcorrencia/RESET_PAGINACAO");
  commit("relatoOcorrencia/SET_LOADING", false);
  commit("relatoOcorrencia/visualizacao/LIMPAR_OCORRENCIA_SELECIONADA");

  limparStorage(
    () => sessionStorage,
    chave =>
      chave === LISTAGEM_STORAGE_KEY ||
      chave === "editar_sq_ocorrencia" ||
      chave.startsWith(WIZARD_STORAGE_PREFIXO) ||
      chave.startsWith(WIZARD_ABA_STORAGE_PREFIXO)
  );
  limparStorage(
    () => localStorage,
    chave =>
      /^(gerovoco_mock_|gerovenv_mock_|dados_ocorrencia_mock_|estado_saude_mock_)/.test(
        chave
      )
  );

  try {
    await limparTodosAnexos();
  } catch (error) {
    console.warn("Erro ao limpar anexos do relato de ocorrência", error);
  }
}
